import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'reactstrap'
import classNames from 'classnames'
import apiBarcode from '../../../services/api/apiBarcode'
import { generateLabelShip, generateLabelByLabelId, bulkUpdateTags } from '../../../services/api/apiNextBarcode'
import { pushNewItemHistory } from '../../../services/api/apiItemHistory'
import CheckBoxCol from './TableData/CheckBoxCol'
import OrderTitleCol from './TableData/OrderTitleCol'
import AddressCol from './TableData/AddressCol'
import CreatedCol from './TableData/CreatedCol'
import DesignBackCol from './TableData/DesignBackCol'
import DesignFrontCol from './TableData/DesignFrontCol'
import DesignSleevesCol from './TableData/DesignSleevesCol'
import LabelShipCol from './TableData/LabelShipCol'
import MockUpBackCol from './TableData/MockUpBackCol'
import MockUpFrontCol from './TableData/MockUpFrontCol'
import ParentActionCol from './TableData/ParentActionCol'
import PrintInfoCol from './TableData/PrintInfoCol'
import ProductionCol from './TableData/ProductionCol'
import VariantCol from './TableData/VariantCol'
import LazyLoad from 'react-lazyload'
import { Tooltip as TooltipAntd, Checkbox, Button, Popover } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons';
import UploadOrderPhoto from './TableData/UploadOrderPhoto'
import { listLineship } from '../../helpers/filtersTable.json'

export const mappingLineShip = (shipping_carrier) => {
    if (!!shipping_carrier) {
        const mappingLineShips = [...listLineship]
        const lineShipName = mappingLineShips.filter(item => item.value === shipping_carrier)

        return lineShipName[0]
    }
}

class ParentRow extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoadingGenerate: false,
            isLoadingDelete: false,
            isLoadingPrint: false,
            isLoadingShip: false,
            isLoadingDuplicate: false,
            tooltipOpen: false,
            checked: false,
            visible: false,
        }
    }

    _setTooltipOpen = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        })
    }

    _renderIconGenerate = () => {
        const { item: _item } = this.props
        const { parent: item } = this._parseProductsItems(_item)
        const { orderLabelDetails } = item
        const lineShip = mappingLineShip(orderLabelDetails && orderLabelDetails.shipping_carrier) || {}

        const {
            'partnerTrackingNumber': orderTrackingNumber,
        } = Object.assign({}, { 'partnerTrackingNumber': '' }, orderLabelDetails)

        const title = orderTrackingNumber ? <span>Có chắc chắn muốn <strong>regen label{lineShip.name ? ` ${lineShip.name}` : ''}</strong> item này?</span> : <span>Có chắc chắn muốn <strong>gen label</strong> item này?</span>
        const content = (
            <div>
                <div style={{ marginBottom: 12 }}>
                    <QuestionCircleOutlined style={{ color: 'red' }} className='mr-1' />
                    {title}
                </div>

                <div className='d-flex align-items-center justify-content-between'>
                    <Checkbox
                        checked={this.state.checked}
                        onChange={e => this.setState({ checked: e.target.checked })}
                    >
                        Detect shipping carrier
                    </Checkbox>

                    <div>
                        <Button size="small" onClick={() => this.setState({ visible: false })}>
                            Hủy
                        </Button>

                        <Button
                            type="primary"
                            size="small"
                            style={{ marginLeft: 8 }}
                            onClick={() => {
                                this._handleClickGenerate()
                                this.setState({ visible: false })
                            }}
                        >
                            Generate
                        </Button>
                    </div>

                </div>
            </div>
        )

        if (this.state.isLoadingGenerate) {
            return <i className='icon-spinner2 spinner ml-3' />
        }

        return (
            <Popover
                content={content}
                trigger="click"
                placement='topRight'
                onVisibleChange={visible => this.setState({ visible })}
                visible={this.state.visible}
            >
                <TooltipAntd title={`Generate Label ${lineShip.name ? `${lineShip.name} ` : ''}`}>
                    <i className='icon-barcode2 text-primary mr-2 mb-2 cursor-pointer' />
                </TooltipAntd>
            </Popover>
        )
    }

    _handleClickGenerate = async () => {
        const { item, reloadItems } = this.props

        try {
            this.setState({ isLoadingGenerate: true })

            const labelId = item.meta && item.meta.label && (/^[0-9a-fA-F]{24}$/.test(item.meta.label.id || '') ? item.meta.label.id : item.meta.label._id)

            if (labelId) {
                const payload = { trigger: 'manual' }
                if (this.state.checked) payload.detectLineShip = true
                const { success, message } = await generateLabelByLabelId(labelId, payload)
                if (!success) throw new Error(message)
            } else {
                const payload = {
                    status: item.gen_at !== undefined ? 'regenerated' : 'generated'
                }

                if (this.state.checked) payload.detectLineShip = true

                const { success, message } = await generateLabelShip(item._id, payload)
                if (!success) throw new Error(message)
            }

            await reloadItems()

        } catch (e) {
            alert(e.message)
            await reloadItems()
        } finally {
            this.setState({
                isLoadingGenerate: false,
                checked: false,
            })
        }
    }

    _renderIconDelete = () => {
        if (this.state.isLoadingDelete)
            return <i className='icon-spinner2 spinner ml-3' />
        return <i className='icon-bin text-danger ml-3' onClick={this._handleClickDelete} />
    }

    _handleClickDelete = async () => {
        const r = window.prompt('Bạn có chắc chắn muốn XÓA đơn hàng này?\nĐơn hàng đã XÓA sẽ không thể khôi phục lại\nGõ "ok" và bấm OK để xóa')
        if (r !== 'ok') {
            console.log('bạn phải gõ "ok" để xóa đơn hàng')
            return
        }

        this.setState({ isLoadingDelete: true })

        try {
            const { item, reloadItems } = this.props

            const resDelete = await apiBarcode.deleteBarcode(item._id)

            const { success, message } = resDelete.data

            if (!success) throw new Error(message)

            await reloadItems()
        } catch (e) {
            alert(e.message)
        }

        this.setState({ isLoadingDelete: false })
    }

    _handleClickEdit = () => {
        const { item, openModalEdit } = this.props
        openModalEdit(item)
    }

    _handleClickReturn = async (item) => {
        const { reloadItems } = this.props
        try {
            // Pull shipped_vhmc, then push returned
            const payload1 = {
                barcode_numbers: [item.barcodeNumber],
                tags: ['shipped_vhmc'],
                action: 'pull'
            }
            const res1 = await bulkUpdateTags(payload1)
            if (!res1.success) throw new Error(res1.message)

            const payload2 = {
                barcode_numbers: [item.barcodeNumber],
                tags: ['returned'],
                action: 'push'
            }
            const res2 = await bulkUpdateTags(payload2)
            if (!res2.success) throw new Error(res2.message)
            
            await reloadItems()
        } catch (e) {
            alert(e.message)
        }
    }

    _handleClickEditCommitTime = () => {
        const { item: rawItem, openModalEditCommitTime } = this.props
        const item = this._parseProductsItems(rawItem).parent

        openModalEditCommitTime(item)
    }

    _handleClickEditProduct = () => {
        const { item, openModalEditProduct } = this.props
        const { production_status } = item
        const {
            _id,
            pos,
            barcodeNumber,
            productId,
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            designSleeveLeft,
            designSleeveRight,
            size,
            color,
            type,
            quantity,
            productStatus,
            note
        } = this._parseProductsItems(item).parent
        const product = {
            barcodeId: _id,
            pos,
            barcodeNumber,
            productId,
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            designSleeveLeft,
            designSleeveRight,
            size,
            color,
            type,
            quantity,
            production_status,
            productStatus,
            tags: item.tags,
            note
        }

        openModalEditProduct(product)
    }

    _handleMarkFaileDesign = () => {
        const { item, openModalMarkFaileDesign } = this.props
        const { production_status, storename } = item
        const {
            _id,
            pos,
            barcodeNumber,
            productId,
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            designSleeveLeft,
            designSleeveRight,
            size,
            color,
            type,
            quantity,
            productStatus,
            note
        } = this._parseProductsItems(item).parent
        const product = {
            barcodeId: _id,
            pos,
            barcodeNumber,
            productId,
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            designSleeveLeft,
            designSleeveRight,
            size,
            color,
            type,
            quantity,
            production_status,
            productStatus,
            note,
            storename
        }

        openModalMarkFaileDesign(product)
    }

    _handleDeleteLabel = async () => {
        const r = window.confirm('Bạn có chắc chắn muốn xóa label này?')
        if (!r) return

        try {
            const { item, reloadItems } = this.props

            const resUpdated = await apiBarcode.updateBarcode(item._id, { labelDetails: null })

            const { success, message } = resUpdated.data

            if (!success) throw new Error(message)

            await reloadItems()

            return pushNewItemHistory(`${item.barcodeNumber}_1`, {
                event_key: 'delete_label',
                event_description: `Delete label`,
                event_meta: {
                    source: 'single_delete_label',
                }
            })
        } catch (e) {
            alert(e.message)
        }

    }

    _handleChange = () => {
        const { item, onChangeSelected, isSelected } = this.props

        onChangeSelected(item._id, !isSelected)
    }

    _parseProductsItems = (item) => {
        const rows = { parent: null, child: [] }
        const { labelDetails: orderLabelDetails, brand_name: orderBrandName, tags: tagOrders = [], sub_status = '', ...itemWithoutProducts } = item
        let products = item.products
        const newTagOrders = tagOrders.filter(t => t !== "is_set") || []

        if (item.hasOwnProperty('filteredProducts')) {
            products = item.filteredProducts
        }

        const product_labels = products.filter(product => {
            return product.hasOwnProperty('labelDetails')
        })

        if (orderLabelDetails) {
            Object.assign(itemWithoutProducts, { 'orderLabelDetails': orderLabelDetails })
        }

        if (orderBrandName) {
            Object.assign(itemWithoutProducts, { 'orderBrandName': orderBrandName })
        }

        const multiLabel = product_labels.length > 0

        Object.assign(itemWithoutProducts, { 'multiLabel': multiLabel })

        const firstProduct = products[0]
        const { _id: productId, status, isShipped, tags: productTags = [], ...restFirstProduct } = firstProduct

        if (multiLabel === true) {
            Object.assign(restFirstProduct, { 'isShipped': isShipped })
        }

        Object.assign(restFirstProduct, { 'hasLabel': restFirstProduct.hasOwnProperty('labelDetails') })

        delete itemWithoutProducts['note']

        rows.parent = (Object.assign({}, itemWithoutProducts, {
            ...restFirstProduct,
            productId,
            productStatus: status,
            tags: Array.from(new Set([...productTags, ...newTagOrders])),
            sub_status, //sub_status của order,
            meta: {
                ...(item.meta || {}),
                ...(restFirstProduct.meta || {})
            }
        }))

        return rows
    }

    _handleClickOpenImageItemLabel = () => {
        const { item, onModalItemLabel } = this.props
        const { split_fba_item_label } = item
        onModalItemLabel(split_fba_item_label)
    }

    _handleClickGenLabelCustomWHL = () => {
        const { item, openModalGenLabelCustomWHL } = this.props
        openModalGenLabelCustomWHL(item)
    }

    render() {
        const { tooltipOpen } = this.state

        const { item: _item, reloadItems, isSelected, orderNote, itemsRequest, onChangeFilterTag, filter, onChangeFilter } = this.props
        const { parent: item } = this._parseProductsItems(_item)
        const { production_status, tags, trackingUrl } = item

        const productStatus = item.productStatus || 'error'
        const commitmentTime = _item && _item.preference && _item.preference.commitment_time || item.commitment_time
        const classNameItem = classNames('d-flex flex-wrap', {
            ListItemsItem: true,
            BorderNone: false,
            'text-success': productStatus === 'completed' && item.status !== 'error',
            disabled: production_status === 'packaged',
            'rowArchived': item.is_archived,
            disabledCancel: production_status === 'cancelled' || production_status === 'on-hold' || item.productStatus === 'cancelled',
            'bg-dark': item.status === 'error',
            'text-warning': item.status === 'error',
            'hold-ship': item.tags.includes('hold-ship'),
            'false-design': item.productStatus === 'false_design',
        })

        return (
            <div className={classNames('itemRowTable', { 'item-error-2d': tags && tags.includes('errQC') })}>
                <LazyLoad>
                    <div className={classNameItem} id={'Tooltip-' + _item._id}>
                        <CheckBoxCol
                            production_status={item.production_status}
                            orderNumber={item.orderNumber}
                            isChecked={Boolean(isSelected)}
                            handleChange={this._handleChange}
                        />

                        <OrderTitleCol
                            barcodeNumber={item.barcodeNumber}
                            orderNumber={item.orderNumber}
                            packageName={item.packageName}
                            storename={item.storename}
                            canViewStore={this.props.canViewStore}
                            _id={item._id}
                            note={item.note}
                            productStatus={item.productStatus}
                            orderNote={orderNote}
                            orderType={item.order_type}
                            fbaWarningLabel={item.fba_warning_label}
                            tags={tags}
                            reloadItems={reloadItems}
                        />

                        <PrintInfoCol
                            pos={item.pos}
                            total={!!item.products && item.products.length}
                            order3d={Boolean(item.order3d)}
                            order3d_at={item.order3d_at}
                            printed_at={item.printed_at} type={item.type}
                            printed_ip={item.printed_ip}
                            barcode_number={item.barcodeNumber}
                            tags={tags}
                        />

                        <MockUpFrontCol mockUpFront={item.mockUpFront} />

                        <MockUpBackCol mockUpBack={item.mockUpBack} />

                        <DesignFrontCol designFront={item.designFront} productStatus={item.productStatus} />

                        <DesignBackCol designBack={item.designBack} productStatus={item.productStatus} />

                        <DesignSleevesCol designSleeves={item.designSleeves} productStatus={item.productStatus} item={item} />

                        <VariantCol type={item.type} brandName={item.brand_name} color={item.color} size={item.size} filter={filter} onChangeFilter={onChangeFilter} />

                        <AddressCol
                            name={item.name}
                            address1={item.address1}
                            address2={item.address2}
                            city={item.city}
                            state={item.state}
                            postalCode={item.postalCode}
                            country={item.country}
                            productStatus={item.productStatus}
                            ghtkAddress={item.ghtk_address}
                            shipmentInfo={item.shipment_info}
                        />

                        <LabelShipCol
                            shipmentCode={item.shipment_code}
                            multiLabel={Boolean(item.multiLabel)}
                            hasLabel={Boolean(item.hasLabel)}
                            production_status={item.production_status}
                            country={item.country}
                            labelDetails={item.labelDetails}
                            orderLabelDetails={item.orderLabelDetails}
                            gen_at={item.gen_at}
                            box_id={item.box_id}
                            boxed_at={item.boxed_at}
                            shipped_at={item.shipped_at}
                            shipped_ip={item.shipped_ip}
                            nextBoxItem={item.nextBoxItem || ''}
                            productStatus={item.productStatus}
                            trackingUrl={trackingUrl}
                            handleDeleteLabel={this._handleDeleteLabel}
                            splitFBAItemLabel={item.split_fba_item_label}
                            orderType={item.order_type}
                            handleClickOpenImageItemLabel={this._handleClickOpenImageItemLabel}
                            tags={tags}
                            packaged_at={item.packaged_at}
                            barcodeNumber={item.barcodeNumber}
                            sub_status={item.sub_status}
                            filter={filter}
                            onChangeFilter={onChangeFilter}
                            meta={item.meta}
                        />
                        <UploadOrderPhoto item={item} reloadItems={reloadItems} />

                        <CreatedCol
                            created={item.created}
                            productStatus={item.productStatus}
                        />

                        <ProductionCol
                            production_time={item.production_time}
                            commitment_time={commitmentTime}
                            productStatus={item.productStatus}
                        />

                         <ParentActionCol
                             tags={tags}
                             tagAddress={this.props.item.tags}
                             production_status={item.production_status}
                             item={item}
                             reloadItems={reloadItems}
                             handleClickEdit={this._handleClickEdit}
                             handleClickEditProduct={this._handleClickEditProduct}
                             renderIconGenerate={this._renderIconGenerate}
                             handleClickMarkFaileDesign={this._handleMarkFaileDesign}
                             itemsRequest={itemsRequest}
                             onChangeFilterTag={onChangeFilterTag}
                             handleClickGenLabelCustomWHL={this._handleClickGenLabelCustomWHL}
                             handleClickReturn={this._handleClickReturn}
                             orderLabelDetails={item.orderLabelDetails}
                             orderType={item.order_type}
                         />

                        {
                            item.is_archived && (
                                <Tooltip
                                    isOpen={tooltipOpen}
                                    target={'Tooltip-' + _item._id}
                                    toggle={this._setTooltipOpen}
                                >
                                    Đã archive
                                </Tooltip>
                            )

                        }
                    </div>
                </LazyLoad>
            </div>
        )
    }
}

ParentRow.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    reloadItems: PropTypes.func.isRequired,
}

export default ParentRow
